import themeOptions from './themeOptions';

export type ThemeMode = 'light' | 'dark';

export const themePresets = themeOptions
  .filter((option) => !option.id.endsWith(' Dark'))
  .map((light) => ({
    id: light.id,
    light,
    dark: themeOptions.find((option) => option.id === `${light.id} Dark`)
  }))
  .filter((preset) => preset.dark != null);

export function findThemePreset(theme: { main?: { palette?: { primary?: { main?: string } } } }) {
  const primary = theme?.main?.palette?.primary?.main;
  return themePresets.find(
    (preset) =>
      preset.light.section.main.palette.primary?.main === primary ||
      preset.dark.section.main.palette.primary?.main === primary
  );
}

export function getThemeSection(preset: (typeof themePresets)[number], mode: ThemeMode) {
  return (mode === 'dark' ? preset.dark : preset.light).section;
}
